import React from 'react';
import {
  faDiscord,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import css from './PageFooter.module.css';

const SOCIAL_ICONS = [
  {
    icon: faDiscord,
    urlPathName: 'https://discord.gg/2WKtKcU',
    activeColor: '#7289da',
  },
  {
    icon: faTwitter,
    urlPathName: 'https://twitter.com/pulsoid_app',
    activeColor: '#1da1f2',
  },
  {
    icon: faYoutube,
    urlPathName: 'https://www.youtube.com/channel/UCy8wTerMdM3mJUWs_39Oa1Q',
    activeColor: '#ff0000',
  },
];

export const PageFooter = () => {
  return (
    <footer className={css.footer}>
      <div className={css.footerLinks}>
        <a
          href="https://pulsoid.net/ui/configuration?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          Get Started
        </a>
        <a
          href="https://pulsoid.net/pricing?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          BRO Plan Subscription
        </a>
        <a
          href="https://www.blog.pulsoid.net/post/how-to-add-real-heart-rate-to-stream?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          How It Works
        </a>
        <a
          href="https://www.blog.pulsoid.net/monitors?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          How To Choose HR Monitor
        </a>
        <a
          href="https://www.blog.pulsoid.net/post/pulsoid-does-not-work-troubleshooting?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          Trouble Shooting
        </a>
      </div>

      <div className={css.footerMiddle}>
        <div className={css.footerSocials}>
          {SOCIAL_ICONS.map((socialIcon) => (
            <a
              key={socialIcon.urlPathName}
              href={socialIcon.urlPathName}
              target="_blank"
              rel="noreferrer"
              style={{
                color: socialIcon.activeColor,
              }}
              className={css.footerSocialsIcon}
            >
              <FontAwesomeIcon size="sm" icon={socialIcon.icon as IconProp} />
            </a>
          ))}
        </div>

        <div className={css.footerRights}>
          <img
            className={css.footerLogo}
            alt="pulsoid"
            src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/partnership/pulsoid-logo-white-small.png"
          />
          <span>© all rights reserved pulsoid 2023</span>
        </div>
      </div>

      <div className={css.footerLinks}>
        <a href="mailto:support@pulsoid.net">support@pulsoid.net</a>
        <a
          href="https://www.blog.pulsoid.net/feature-request?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          Feature request
        </a>
        <a
          href="https://pulsoid.net/s/media-pack?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          Media pack
        </a>
        <a
          href="https://www.blog.pulsoid.net/partners?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          Partners
        </a>
        <a
          href="https://www.blog.pulsoid.net?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          Blog
        </a>
        <a
          href="https://pulsoid.net/legal?from=footer"
          target="_blank"
          rel="noreferrer"
        >
          Terms of Service
        </a>
      </div>
    </footer>
  );
};
